import * as adjustmentData from '../services/adjustmentData';

export default {
  namespace: 'adjustmentData',

  state: {
    viewList: [],
    allTotal: 0,
  },

  effects: {
    *getViewList({ payload: { values } }, { call, put }) {
      const response = yield call(adjustmentData.getViewList, values);
      yield put({
        type: 'save',
        payload: {
          viewList: response?.data,
        },
      });
    },
    *getViewListNum({ payload: { values } }, { call, put }) {
      const response = yield call(adjustmentData.getViewList, values);
      yield put({
        type: 'save',
        payload: {
          allTotal: response?.data?.total,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
